import React, { useEffect, useRef } from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';

const ModalContainer = styled.div<StyledProps>`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(51, 51, 51, 0.85);
  z-index: 100;
  pointer-events: none;
  opacity: 0;
  transition: opacity 300ms ease;
`;

const ModalContent = styled.div<StyledProps>`
  width: 100%;
  height: 100%;
  display: flex;
`;
const Body = styled.div<StyledProps>`
  background-color: ${(props) => props.theme?.colors.white + ""};
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const visable = css`
  pointer-events: auto;
  opacity: 1;
  transition: all 300ms ease-in-out;
`;

const visableContent = css`
  opacity: 1;
  // transform: scale(1);
  transition: opacity 300ms ease, transform 500ms 500ms ease;
`;

interface StyledProps {
  theme?: ITheme;
}

export interface ModalProps {
  children?: React.ReactNode;
  show: boolean;
  onClose: () => void;
  theme?: ITheme;
  className?: string | undefined;
}

function QRSuccessModal({ children, show, onClose, className }: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const contentModalRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  useEffect(() => {
    if (!modalRef.current || !contentModalRef.current) {
      return;
    }
    if (show) {
      modalRef?.current.classList.add(visable);
      contentModalRef.current.classList.add(visableContent);
    } else {
      modalRef.current.classList.remove(visable);
      contentModalRef.current.classList.remove(visableContent);
    }
    
  }, [show]);
  return (
    <ModalContainer onClick={onClose} ref={modalRef} theme={theme} className={className}>
      <ModalContent onClick={(e)=>{e.stopPropagation()}} ref={contentModalRef} className="modal-content">
        <Body theme={theme} className="modal-body">
          {children}
        </Body>
      </ModalContent>
    </ModalContainer>
  );
}

QRSuccessModal.defaultProps = {
  show: false,
  onClose: () => {},
};

export default QRSuccessModal;
